import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import {
    getPrivacySettingRequest,
    updatePrivacySettingRequest,
} from "../../store/user/privacysetting/privacysetting.actions";
import { getCurrentPrivacySetting } from "../../store/user/privacysetting/privacysetting.selector";

const notification = [
    {
        id: 0,
        title: "Followers",
        message: "People that I follow may message me",
        guest: "",
    },
    {
        id: 1,
        title: "Following",
        message: "People that I follow may message me",
        guest: "",
    },
    {
        id: 2,
        title: "Meeting Room",
        message: "Make Meeting Room Public",
        guest: "",
    },
    {
        id: 3,
        title: "Subscribers",
        message: "People that subscribe to me may message me",
        guest: "",
    },
    {
        id: 4,
        title: "Followers",
        message: "People that I follow may message me",
        guest: "Guest Invitation",
    },
    {
        id: 5,
        title: "Buyer",
        message: "People that purchased a product may message me",
        guest: "Guest Invitation",
    },
];

const PrivacySettings = () => {
    const dispatch = useDispatch();
    const [values, setValues] = useState({
        allowFollowerInbox: false,
        allowFollowingInbox: false,
        allowSubscriberInbox: false,
        allowPurchasedInbox: false,
        allowFollowingInvite: false,
        meetingRoomPrivate: false,
    });
    const { privacysetting } = useSelector((state) => {
        return {
            privacysetting: getCurrentPrivacySetting(state),
        };
    });

    useEffect(() => {
        setValues({
            allowFollowerInbox: privacysetting.allowFollowerInbox,
            allowFollowingInbox: privacysetting.allowFollowingInbox,
            allowSubscriberInbox: privacysetting.allowSubscriberInbox,
            allowPurchasedInbox: privacysetting.allowPurchasedInbox,
            allowFollowingInvite: privacysetting.allowFollowingInvite,
            meetingRoomPrivate: privacysetting.meetingRoomPrivate,
        });
    }, [privacysetting]);

    useEffect(() => {
        dispatch(getPrivacySettingRequest());
    }, []);

    const handleSave = (flag, value) => {
        let updated = privacysetting;
        updated[value] = flag;

        dispatch(updatePrivacySettingRequest(updated));
    };
    return (
        <div>
            <div className="flex items-center justify-between gap-x-3 pb-3 border-b border-black-10 mb-4">
                <div className="text-sm">
                    <h3 className="font-bold text-ebony-color mb-0.5">
                        Email Notifications
                    </h3>
                    <p className="text-black-60">
                        Get emails to find out what’s going on when you’re not
                        on Ulalive. You can turn them off anytime.
                    </p>
                </div>
                <ToggleButton
                    enabled={values.allowFollowingInvite}
                    onChange={(flag) => {
                        setValues({ ...values, allowFollowingInvite: flag });
                        handleSave(flag, "allowFollowingInvite");
                    }}
                />
            </div>

            <div className="">
                <h2 className="text-base font-bold text-ebony-color mb-0.5">
                    In Mail
                </h2>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Followers
                        </h4>
                        <p className="text-black-60">
                            People that follow me may message me
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowFollowerInbox}
                        onChange={(flag) => {
                            setValues({ ...values, allowFollowerInbox: flag });
                            handleSave(flag, "allowFollowerInbox");
                        }}
                    />
                </div>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Following
                        </h4>
                        <p className="text-black-60">
                            People that I follow may message me
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowFollowingInbox}
                        onChange={(flag) => {
                            setValues({ ...values, allowFollowingInbox: flag });
                            handleSave(flag, "allowFollowingInbox");
                        }}
                    />
                </div>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Meeting Room
                        </h4>
                        <p className="text-black-60">
                            Make Meeting Room Public
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.meetingRoomPrivate}
                        onChange={(flag) => {
                            setValues({ ...values, meetingRoomPrivate: flag });
                            handleSave(flag, "meetingRoomPrivate");
                        }}
                    />
                </div>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Subscriber
                        </h4>
                        <p className="text-black-60">
                            People that subscribe to me may message me
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowSubscriberInbox}
                        onChange={(flag) => {
                            setValues({
                                ...values,
                                allowSubscriberInbox: flag,
                            });
                            handleSave(flag, "allowSubscriberInbox");
                        }}
                    />
                </div>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Buyer
                        </h4>
                        <p className="text-black-60">
                            People that purchased a product may message me
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowPurchasedInbox}
                        onChange={(flag) => {
                            setValues({ ...values, allowPurchasedInbox: flag });
                            handleSave(flag, "allowPurchasedInbox");
                        }}
                    />
                </div>
            </div>

            <div className="">
                <h2 className="text-base font-bold text-ebony-color mb-0.5">
                    Guest invitation
                </h2>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            Following
                        </h4>
                        <p className="text-black-60">
                            People that I follow may invite me
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowFollowingInvite}
                        onChange={(flag) => {
                            setValues({
                                ...values,
                                allowFollowingInvite: flag,
                            });
                            handleSave(flag, "allowFollowingInvite");
                        }}
                    />
                </div>
            </div>

            <div className="">
                <h2 className="text-base font-bold text-ebony-color mb-0.5">
                    From Ulalive
                </h2>
                <div className="flex items-center justify-between gap-x-3 py-3 border-b border-black-10">
                    <div className="text-sm">
                        <h4 className="text-ebony-color font-bold mb-0.5 capitalize">
                            News
                        </h4>
                        <p className="text-black-60">
                            News about Ulalive product and features updates
                        </p>
                    </div>
                    <ToggleButton
                        enabled={values.allowFollowingInvite}
                        onChange={(flag) => {
                            setValues({
                                ...values,
                                allowFollowingInvite: flag,
                            });
                            handleSave(flag, "allowFollowingInvite");
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default PrivacySettings;
